import { useQuery } from '@tanstack/react-query';
import {
  docusignInspectorApi,
  docusignInspectorKeys,
  type DocusignTemplateTabsResponse,
} from '@client/api/waterlily';

interface UseDocusignTemplateTabsParams {
  formId: string | null | undefined;
  enabled?: boolean;
}

export function useDocusignTemplateTabs({ formId, enabled = true }: UseDocusignTemplateTabsParams) {
  return useQuery<DocusignTemplateTabsResponse>({
    queryKey: docusignInspectorKeys.list({ formId, type: 'template-tabs' }),
    queryFn: () => docusignInspectorApi.getTemplateTabs(formId!),
    enabled: enabled && !!formId,
    staleTime: 60_000,
  });
}
